export default [{
    path: "/workgroup/view/:id",
    component: () => import( /* webpackChunkName: "workgroup" */ '@/page/workgroup/view.vue')
}]